module.exports = __webpack_public_path__ + "static/img/m_name.86c38dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/sy/m_name.png
// module id = GD9n
// module chunks = 7